module.exports = {
	"dateTime": "%A, der %e. %B %Y, %X",
	"date": "%d.%m.%Y",
	"time": "%H:%M:%S",
	"periods": [
		"vormittags",
		"nachmittags"
	],
	"days": [
		"Sonntag",
		"Montag",
		"Dienstag",
		"Mittwoch",
		"Donnerstag",
		"Freitag",
		"Samstag"
	],
	"shortDays": [
		"So",
		"Mo",
		"Di",
		"Mi",
		"Do",
		"Fr",
		"Sa"
	],
	"months": [
		"Januar",
		"Februar",
		"März",
		"April",
		"Mai",
		"Juni",
		"Juli",
		"August",
		"September",
		"Oktober",
		"November",
		"Dezember"
	],
	"shortMonths": [
		"Jan",
		"Feb",
		"Mrz",
		"Apr",
		"Mai",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Okt",
		"Nov",
		"Dez"
	],
	"decimal": ",",
	"thousands": "'",
	"grouping": [
		3
	],
	"currency": [
		"",
		" CHF"
	]
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/de-ch-locale/de-ch.json
// module id = 21
// module chunks = 0